import { api } from '@/services/api'

export async function deleteMessageOnFirebase(messageId: string) {
  await api.delete(`/messages/${messageId}`)
}
